// // CorporateFilter.js
// import React, { useState, useEffect } from "react";
// import TextField from "@mui/material/TextField";
// import Autocomplete from "@mui/material/Autocomplete";
// import useHttp from "../../Hooks/use-http";
// const CorporateFilter = ({
//   selectedCorporate,
//   setSelectedCorporate,
//   corporateData,
//   setCorporateData,
//   mainData,
//   setFilteredData,
//   loading,
//   // setIsRefreshCorporate,
//   setIsRefereshData,
//   isMobile = false,

//   // onCorporateSelect,
// }) => {
//   const { sendRequest } = useHttp();
//   useEffect(() => {
//     sendRequest(
//       {
//         // url: "/api/v1/Corporate/GetAllDepartmentByCorporate",
//         url: "/corporates",
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: {
//           emailID: localStorage.getItem("user"),
//         },
//       },
//       corporateLists
//     );
//   }, [sendRequest]);

//   const corporateLists = (data) => {
//     const tempArr =
//       data?.corporates
//         ?.filter((el) => el.parentID === null)
//         ?.map((cp) => ({
//           cpName: cp?.name,
//           cpId: cp?.corporateID,
//           dpId: cp?.departmentID,
//           adminDptId:
//             cp?.DepartmentID?.split(",")[
//               cp?.DepartmentName?.toLowerCase()?.split(",").indexOf("admin")
//             ] || "",
//         })) || [];
//     setCorporateData(tempArr);
//   };

//   const handleCorporateChange = (event, newValue) => {
//     if (newValue) {
//       const selectedData = corporateData.filter(
//         (data) => data?.cpName === newValue
//       );
//       setSelectedCorporate(selectedData);

//       setIsRefereshData((prev) => !prev);
//     } else {
//       setSelectedCorporate([]);
//       setFilteredData(mainData);
//     }
//   };

//   return (
//     <div>
//       <Autocomplete
//         id="corporate-filter"
//         disabled={loading == true}
//         options={corporateData && corporateData?.map((data) => data?.cpName)}
//         sx={{ width: 200 }}
//         renderInput={(params) => (
//           <TextField
//             {...params}
//             variant="standard"
//             placeholder="Search Corporate Name"
//             label="Corporate Name"
//           />
//         )}
//         onChange={(e, newValue) =>
//           // corporateNameClickHandler(e, newValue)
//           handleCorporateChange(e, newValue)
//         }
//         value={
//           selectedCorporate && selectedCorporate.length > 0
//             ? selectedCorporate[0].cpName
//             : ""
//         }
//       />
//     </div>
//   );
// };

// export default CorporateFilter;

// CorporateFilter.js
import React, { useState, useEffect } from "react";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import useHttp from "../../Hooks/use-http";
import { useTheme, useMediaQuery } from "@mui/material";

const CorporateFilter = ({
  selectedCorporate,
  setSelectedCorporate,
  corporateData,
  setCorporateData,
  mainData,
  setFilteredData,
  loading,
  setIsRefereshData,
  isMobile = false,
}) => {
  const { sendRequest } = useHttp();
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

  useEffect(() => {
    sendRequest(
      {
        url: "/corporates",
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: {
          emailID: localStorage.getItem("user"),
        },
      },
      corporateLists
    );
  }, [sendRequest]);

  const corporateLists = (data) => {
    const tempArr =
      data?.corporates
        ?.filter((el) => el.parentID === null)
        ?.map((cp) => ({
          cpName: cp?.name,
          cpId: cp?.corporateID,
          dpId: cp?.departmentID,
          adminDptId:
            cp?.DepartmentID?.split(",")[
              cp?.DepartmentName?.toLowerCase()?.split(",").indexOf("admin")
            ] || "",
        })) || [];
    setCorporateData(tempArr);
  };

  const handleCorporateChange = (event, newValue) => {
    if (newValue) {
      const selectedData = corporateData.filter(
        (data) => data?.cpName === newValue
      );
      setSelectedCorporate(selectedData);
      setIsRefereshData((prev) => !prev);
    } else {
      setSelectedCorporate([]);
      setFilteredData(mainData);
    }
  };

  return (
    <div>
      <Autocomplete
        id="corporate-filter"
        disabled={loading === true}
        options={corporateData && corporateData?.map((data) => data?.cpName)}
        sx={{ width: isSmallScreen ? "100%" : 200 }}
        renderInput={(params) => (
          <TextField
            {...params}
            variant="standard"
            placeholder="Search Corporate Name"
            label="Corporate Name"
            size={isSmallScreen ? "small" : "medium"}
          />
        )}
        onChange={handleCorporateChange}
        value={
          selectedCorporate && selectedCorporate.length > 0
            ? selectedCorporate[0].cpName
            : ""
        }
      />
    </div>
  );
};

export default CorporateFilter;
